// src/components/InfoModal.js
import React, { useState, useEffect } from 'react';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';

import ContactSocials from './ContactSocials';

/**
 * InfoModal
 * Props:
 * - title: string
 * - content: Strapi blocks
 * - children?: vaste inhoud in plaats van Strapi blocks
 * - onClose: () => void
 * - show: boolean
 * - loading: boolean
 * - showSocial?: boolean   // ← toont social-blok onderaan
 */
function InfoModal({ title, content, children, onClose, show, loading, showSocial = false }) {
  const [showModalContent, setShowModalContent] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowModalContent(show);
    }, 50);
    return () => clearTimeout(timer);
  }, [show]);

  if (!show) {
    return null;
  }

  return (
    <div className={`modal-backdrop ${showModalContent ? 'show' : ''}`} onClick={onClose}>
      <div
        className={`modal-content info-modal ${showModalContent ? 'show' : ''}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="info-modal-header">
          <h2>{title || ''}</h2>
          <button className="info-modal-close-btn" onClick={onClose}>×</button>
        </div>

        <div className="info-modal-body">
          {children || (loading ? (
            <p>Wordt geladen...</p>
          ) : content ? (
            <BlocksRenderer content={content} />
          ) : (
            <p>Hier staat nog niets.</p>
          ))}
        </div>

        {showSocial && (
          <div className="info-modal-footer" style={{ marginTop: '1rem' }}>
            <ContactSocials />
          </div>
        )}
      </div>
    </div>
  );
}

export default InfoModal;
